// Que buzones ve una persona, con la misma regla que aplica el servicio de correo (D38, D83). Un buzon cuyo correo es
// el de alguien del equipo es personal: solo lo ve esa persona, aunque este en un grupo o compartido. Un buzon de grupo
// lo ven solo los miembros del grupo (ser administrador no da acceso). Un buzon sin grupo se ve si es propio.
type Cuenta = { id: string; correo: string; compartido: boolean };
type Grupo = { cuentaId?: string | null; miembros: string[]; activo?: boolean };
type Miembro = { id: string; email?: string | null };

const norm = (s?: string | null) => String(s ?? '').trim().toLowerCase();

export function buzonesVisibles<C extends Cuenta>(cuentas: C[], grupos: Grupo[], miembros: Miembro[], miembroId?: string | null): C[] {
  const duenoDe = new Map(miembros.filter((m) => m.email).map((m) => [norm(m.email), m.id]));
  return cuentas.filter((c) => {
    const dueno = duenoDe.get(norm(c.correo));
    if (dueno) return dueno === miembroId;
    const g = grupos.find((x) => x.cuentaId === c.id && x.activo !== false);
    if (!g) return !c.compartido;
    return !!miembroId && g.miembros.includes(miembroId);
  });
}
